import { httpClient } from '@connectors/HttpClient'

import type { Invitee } from '../types'

export const InviteeService = {
    list: async (): Promise<Invitee[]> => {
        const response = await httpClient.axios.get('/admin/invitees')
        return response.data
    },
    resendInvite: async (inviteeId: string): Promise<any> => {
        const response = await httpClient.axios.post(`/admin/invitees/${inviteeId}/resend`)
        return response.data
    },
    copyInviteLink: async (inviteeId: string): Promise<any> => {
        const response = await httpClient.axios.post(`/admin/invitees/${inviteeId}/copy-link`)
        return response.data
    }
}
